<template>
  <div>
    <b-img
      alt="logo"
      style="max-height: 20vh; min-width: 100%; object-fit: cover;"
      src="./assets/HeaderCheckOut.jpg"
    ></b-img>
    <div class="container">
      <div class="log-form" v-show="showCardEntry">
        <Card-entry v-on:complete-purchase="onCompletePurchase()" />
      </div>
      <div class="text-center" v-show="showSuccess">
        <h1 class="display-3">Thank You!</h1>
        <h3 class="lead"></h3>
        <p class="lead">
          <strong>Please confirm your order via sms text message</strong> and then please check your email for order confirmation details.
        </p>
        <hr />
        <p class="lead">
          <a
            class="btn btn-primary btn-sm"
            href="https://shopcbd.col-care.com"
            role="button"
          >Back to shop</a>
        </p>
      </div>
      <b-alert v-model="showSuccessAlert" variant="success" show>{{successMessage}}</b-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {
    CardEntry
  },
  data() {
    return {
      showCardEntry: true,
      showSuccess: false,
      showDismissibleAlert: false,
      alertMessage: "",
      successMessage: "",
      showSuccessAlert: false
    };
  },
  methods: {
    onCompletePurchase() {
      this.showCardEntry = false;
      this.showSuccess = true;
    }
  }
};

import CardEntry from "./components/CardEntry.vue";
</script>

<style>
.btn {
  background-color: #38b2fa !important;
  border-color: #38b2fa !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.log-form {
  background: #fff;
  margin-top: 15px;
}
@media (max-width: 40em) {
  .log-form {
    width: 95%;
    position: relative;
    margin: 2.5% auto 0 auto;
    left: 0%;
    -webkit-transform: translate(0%, 0%);
    -moz-transform: translate(0%, 0%);
    -o-transform: translate(0%, 0%);
    -ms-transform: translate(0%, 0%);
    transform: translate(0%, 0%);
  }
}
.log-form form {
  display: block;
  width: 100%;
  padding: 2em;
}
.log-form h2 {
  color: #ffffff;
  font-size: 1.35em;
  display: block;
  background: #38b2fa;
  width: 100%;
  padding: 0.75em 1em 0.75em 1.5em;
  box-shadow: inset 0px 1px 1px rgba(255, 255, 255, 0.2);
  border: 1px solid #38b2fa;
  margin: 0;
  font-weight: 200;
}
.log-form .btn {
  display: inline-block;
  color: white;
  margin-right: 0.5em;
  box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.2);
}
.log-form .btn:focus {
  outline: none;
}
</style>
